import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const CardContentSpinner = ({
  minHeight
}) => {
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    "data-test-id": "crm-card-loading-spinner",
    grow: true,
    layout: "centered",
    minHeight: minHeight
  });
};
export default CardContentSpinner;